import onboardingNotEverything from '../assets/images/onboardingNotEverything.png'
import onboardingNotEverything2x from '../assets/images/onboardingNotEverything@2x.png'

/**
 * OnboardingNotEverythingIcon Component
 *
 * Displays the icon for the third onboarding slide.
 * Supports retina displays with @2x image asset.
 *
 * @example
 * <OnboardingNotEverythingIcon />
 */
export const OnboardingNotEverythingIcon = () => {
  return (
    <img
      src={onboardingNotEverything}
      srcSet={`${onboardingNotEverything} 1x, ${onboardingNotEverything2x} 2x`}
      alt="Not everything - focus on the right tasks"
      className="onboarding-icon"
      width={148}
      height={148}
    />
  )
}
